(function() {
	var ListingApprover = (function() {
		var __private = {
			approveButtonClass: "appListing",
			rejectButtonClass: "rejListing",
			relistButtonClass: "relist",
			rejectLinkClass: "rejectSubmit",
			resetLinkClass: "rejectReset",
			reasonAreaClass: "listing-approved-reason__text",
			textareaClass: "reasonTextarea",
			popupClass: "listing-approved-section__popup",
			openClass: "open",
			closeButtonClass: "close",
			disabledClass: "disabled",
			listingIdAttr: "data-listung-id",
			listingStatusAttr: "data-status",
			formActionAttr: "data-action",
			listingStatus: {
				draft: 0,
				pendingApproval: 1,
				private: 2,
				public: 3,
				sold: 4,
				archived: 5
			},
			submitStatus: {
				allDisabled: 0,
				rejEnabled : 1,
				appEnabled : 2,
				allEnabled : 3
			},
			map: {},

			form: null,
			status: false,
			action: false,

			set(options) {
				if(options && options instanceof Object) {
					if(options.approveButtonClass) this.approveButtonClass = options.approveButtonClass;
					if(options.rejectButtonClass)  this.rejectButtonClass = options.rejectButtonClass;
					if(options.rejectLinkClass)    this.rejectLinkClass = options.rejectLinkClass;
					if(options.resetLinkClass)     this.resetLinkClass = options.resetLinkClass;
					if(options.reasonAreaClass)    this.reasonAreaClass = options.reasonAreaClass;
					if(options.textareaClass)      this.textareaClass = options.textareaClass;
					if(options.popupClass)         this.popupClass = options.popupClass;
					if(options.openClass)          this.openClass = options.openClass;
					if(options.disabledClass)      this.disabledClass = options.disabledClass;
					if(options.listingIdAttr)      this.listingIdAttr = options.listingIdAttr;
				}

				// create status map
				this.map = this.statusMap();
			},

			statusMap() {
				var map = {};
				
				map[__private.listingStatus.draft]           = __private.submitStatus.allDisabled;
				map[__private.listingStatus.pendingApproval] = __private.submitStatus.allEnabled;
				map[__private.listingStatus.private]         = __private.submitStatus.rejEnabled;
				map[__private.listingStatus.public]          = __private.submitStatus.rejEnabled;
				map[__private.listingStatus.sold]            = __private.submitStatus.allDisabled;
				map[__private.listingStatus.archived]        = __private.submitStatus.allDisabled;

				return map;
			},

			switcher() {
				var forms = document.querySelectorAll(`form[${this.listingStatusAttr}]`);

				for (let i = 0; i < forms.length; i++) {
					const f = forms[i];
					
					let status = f.getAttribute(this.listingStatusAttr);
					let action = this.getFormAction(status, f);

					if(action && f instanceof HTMLFormElement) f.action = action;
				}
			},

			getFormAction(status, form) {
				var action = false;

				if(this.map.hasOwnProperty(status)) action = this.buttonsOnOff(this.map[status], form);

				return action;
			},

			buttonsOnOff(status, form) {
				var action = false;
				var rejButton = form.getElementsByClassName(this.rejectButtonClass)[0];
				var appButton = form.getElementsByClassName(this.approveButtonClass)[0];

				switch (status) {
					case this.submitStatus.allDisabled:
						if(rejButton instanceof HTMLInputElement) rejButton.disabled = true;
						if(appButton instanceof HTMLInputElement) appButton.disabled = true;
						break;

					case this.submitStatus.allEnabled:
						if(rejButton instanceof HTMLInputElement) rejButton.disabled = false;
						if(appButton instanceof HTMLInputElement) appButton.disabled = false;
						break;

					case this.submitStatus.appEnabled:
						if(rejButton instanceof HTMLInputElement) rejButton.disabled = true;
						if(appButton instanceof HTMLInputElement) {
							appButton.disabled = false;
							action = appButton.getAttribute(this.formActionAttr);
						}
						break;

					case this.submitStatus.rejEnabled:
						if(rejButton instanceof HTMLInputElement) {
							rejButton.disabled = false;
							action = rejButton.getAttribute(this.formActionAttr);
						}
						if(appButton instanceof HTMLInputElement) appButton.disabled = true;
						break;
				
					default:
						break;
				}

				return action;
			},

			setAction(button) {
				var btnStatus;
				var form;
				var action;

				form = button.form;

				if(form instanceof HTMLElement && form.getAttribute(__private.listingStatusAttr))
					btnStatus = __private.map[form.getAttribute(__private.listingStatusAttr)];

				if(btnStatus === __private.submitStatus.allEnabled)
					action = button.getAttribute(__private.formActionAttr);
				
				if(action) form.action = action;
			},

			listener() {
				document.addEventListener("click", function(event) {
					event = event || window.event;
					var target = event.target;

					if(target instanceof HTMLElement) {
						
						// event for approveButton, clear reason text
						if(target.classList.contains(__private.approveButtonClass)) {
							event.preventDefault();
							
							__private.setAction(target);
							__private.approveButtonEvent(target);
						}

						// event for rejectButton, open popup
						if(target.classList.contains(__private.rejectButtonClass)) {
							event.preventDefault();

							__private.setAction(target);
							__private.rejectButtonEvent(target);

							if(target instanceof HTMLInputElement) __private.form = target.form;
						}

						if(target.classList.contains(__private.relistButtonClass)) {
							event.preventDefault();

							__private.setAction(target);
							__private.approveButtonEvent(target);

							const statusCellEL = target.closest('.status-cell');
							const statusLabelEl = statusCellEL.querySelector('.status-label');

							statusLabelEl.textContent = 'Relisted';
						}

						// event for popup's close button (x)
						if(target.classList.contains(__private.closeButtonClass)) {
							event.preventDefault();
							__private.closeButtonEvent(target);
						}

						// event for rejectLink, clear textarea and close popup
						if(target.classList.contains(__private.resetLinkClass)) {
							event.preventDefault();
							__private.resetLinkEvent(target);
						}

						// event for rejectLink, in popup
						if(target.classList.contains(__private.rejectLinkClass)) {
							event.preventDefault();
							__private.rejectLinkEvent(target);
						}
					}
				});
			},

			textareaEvent(textarea) {
				var popup = searchElementByClassName(textarea, __private.popupClass);
				var rejectButton = null;

				if(popup instanceof HTMLElement) rejectButton = popup.getElementsByClassName(__private.rejectLinkClass)[0];

				if(rejectButton === null) throw new Error("Reject button not found (error in Popup)");

				textarea.addEventListener("input", function() {
					if(this.value.length > 0) rejectButton.classList.remove(__private.disabledClass);
					else rejectButton.classList.add(__private.disabledClass);
				});
			},

			approveButtonEvent(button) {
				var form;
				var textarea;

				if(button instanceof HTMLInputElement) {
					form = button.form;

					if(form instanceof HTMLFormElement) {
						textarea = form.getElementsByClassName(__private.textareaClass)[0];
						if(textarea instanceof HTMLTextAreaElement) textarea.value = "";

						setTimeout(() => {
							form.submit();
						}, 100);
					}
				}
			},

			rejectButtonEvent(button) {
				var listingID = button.getAttribute(__private.listingIdAttr);
				var popup = document.querySelector(`.${__private.popupClass}[${__private.listingIdAttr}='${listingID}']`);
				var textarea;

				if(popup instanceof HTMLElement) {
					popup.classList.add(__private.openClass);

					textarea = popup.getElementsByClassName(__private.textareaClass)[0];
					if(textarea instanceof HTMLTextAreaElement) __private.textareaEvent(textarea);
				}
			},

			rejectLinkEvent(link) {
				var popup = searchElementByClassName(link, __private.popupClass);
				var textarea;
				//var reasonarea;

				if(__private.form instanceof HTMLFormElement && !link.classList.contains(__private.disabledClass)) {
					__private.form.submit();

					setTimeout(() => {
						link.classList.add(__private.disabledClass);
					}, 100);
				}
			},

			resetLinkEvent(link) {
				var popup = searchElementByClassName(link, __private.popupClass);
				var textarea;

				if(popup instanceof HTMLElement) {
					textarea = popup.getElementsByClassName(__private.textareaClass)[0];

					if(textarea instanceof HTMLTextAreaElement) textarea.value = "";

					setTimeout(() => {
						popup.classList.remove(__private.openClass);
					}, 100);
				}
			},

			closeButtonEvent(button) {
				var popup = searchElementByClassName(button, __private.popupClass);

				if(popup instanceof HTMLElement)
					popup.classList.remove(__private.openClass);
			}
		};

		return {
			init(options) {
				__private.set(options);
				__private.switcher();
				__private.listener();
			}
		};
	})();

	document.addEventListener("DOMContentLoaded", function() {
		var table = document.querySelector("#admin .listings_all");

		if(table instanceof HTMLElement) {
			ListingApprover.init();
		}
	});
})();
